import { useState, useContext } from "react";
import TabPanel from "../TabPanel";
import Box from "@mui/material/Box";
import MainContext from "../../context/mainContext";
import AccessDeny from "./AccessDeny";
import { ToastContainer } from "react-toastify";

import UserInfoMenu from "./userInfo/userInfoMenu";
import UserInfoTabs from "./userInfo/userInfoTabs";

import PackagesMenu from "./packages/PackagesMenu";
import PackagesTabs from "./packages/PackagesTabs";

// import AcademiesMenu from "./academies/AcademiesMenu";
// import AcademiesTabs from "./academies/AcademiesTabs";

import AccountingMenu from "./accounting/AccountingMenu";
import AccountingTabs from "./accounting/AccountingTabs";

import ReferralMenu from "./referral/ReferralMenu";
import ReferralTabs from "./referral/ReferralTabs";

// import ScoresMenu from "./scores/ScoresMenu";
// import ScoresTabs from "./scores/ScoresTabs";

import LeitnerMenu from "./Leitner/LeitnerMenu";
import LeitnerTabs from "./Leitner/LeitnerTabs";

import SubtitlesMenu from "./subtitles/SubtitlesMenu";
import SubtitlesTabs from "./subtitles/SubtitlesTabs";

import InfluencerMenu from "./Influencer/InfluencerMenu";
import InfluencerTabs from "./Influencer/InfluencerTabs";

import SupportMenu from "./support/SupportMenu";
import SupportTabs from "./support/SupportTabs";

import ContactUsMenu from "./ContactUs/ContactUsMenu";
import ContactUsTabs from "./ContactUs/ContactUsTabs";

import VocabularyMenu from "./vocabulary/VocabularyMenu";
import VocabularyTabs from "./vocabulary/VocabularyTabs";

function MainPages(props) {
  const { handleOpenSignInBox, userTypes } = useContext(MainContext);
  const { mainPageNumber } = props;
  const [userInfoTabsValue, setUserInfoTabsValue] = useState(0);
  const [packagesTabsValue, setPackagesTabsValue] = useState(0);
  const [academiesTabsValue, setAcademiesTabsValue] = useState(0);
  const [accountingTabsValue, setAccountingTabsValue] = useState(0);
  const [referralTabsValue, setReferralTabsValue] = useState(0);
  const [scoresTabsValue, setScoresTabsValue] = useState(0);
  const [subtitlesTabsValue, setSubtitlesTabsValue] = useState(0);
  const [supportTabsValue, setSupportTabsValue] = useState(0);
  const [contactUsTabsValue, setContactUsTabsValue] = useState(0);
  const [vocabularyTabsValue, setVocabularyTabsValue] = useState(0);
  const [leitnerTabsValue, setLeitnerTabsValue] = useState(0);
  const [influencerTabsValue, setInfluencerTabsValue] = useState(0);


  const handlesetUserInfoTabsValue = (event, newValue) => {
    setUserInfoTabsValue(newValue);
  };
  const handlesetPackagesTabsValue = (event, newValue) => {
    setPackagesTabsValue(newValue);
  };
  const handlesetAcademiesTabsValue = (event, newValue) => {
    setAcademiesTabsValue(newValue);
  };
  const handlesetAccountingTabsValue = (event, newValue) => {
    setAccountingTabsValue(newValue);
  };
  const handlesetReferralTabsValue = (event, newValue) => {
    setReferralTabsValue(newValue);
  };
  const handlesetScoresTabsValue = (event, newValue) => {
    setScoresTabsValue(newValue);
  };
  const handlesetLeitnerTabsValue = (event, newValue) => {
    setLeitnerTabsValue(newValue);
  };
  const handlesetSubtitlesTabsValue = (event, newValue) => {
    setSubtitlesTabsValue(newValue);
  };
  const handlesetInfluencerTabsValue = (event, newValue) => {
    setInfluencerTabsValue(newValue);
  };
  const handlesetSupportTabsValue = (event, newValue) => {
    setSupportTabsValue(newValue);
  };
  const handlesetContactUsTabsValue = (event, newValue) => {
    setContactUsTabsValue(newValue);
  };
  const handlesetVocabularyTabsValue = (event, newValue) => {
    // console.log(newValue, vocabularyTabsValue);

    setVocabularyTabsValue(newValue);
  };

  const UserInfoPage =
    userTypes.length > 0 ? (
      <>
        <UserInfoMenu
          userInfoTabsValue={userInfoTabsValue}
          handlesetUserInfoTabsValue={handlesetUserInfoTabsValue}
        />
        <UserInfoTabs userInfoTabsValue={userInfoTabsValue} />
      </>
    ) : (
      <AccessDeny />
    );
  const PackagesPage =
    userTypes.length > 0 ? (
      <>
        <PackagesMenu
          packagesTabsValue={packagesTabsValue}
          handlesetPackagesTabsValue={handlesetPackagesTabsValue}
        />
        <PackagesTabs packagesTabsValue={packagesTabsValue} />
      </>
    ) : (
      <AccessDeny />
    );
  // const AcademiesPage =
  //   userTypes.length > 0 ? (
  //     <>
  //       <AcademiesMenu
  //         academiesTabsValue={academiesTabsValue}
  //         handlesetAcademiesTabsValue={handlesetAcademiesTabsValue}
  //       />
  //       <AcademiesTabs academiesTabsValue={academiesTabsValue} />
  //     </>
  //   ) : (
  //     <AccessDeny />
  //   );
  const AccountingPage =
    userTypes.length > 0 ? (
      <>
        <AccountingMenu
          accountingTabsValue={accountingTabsValue}
          handlesetAccountingTabsValue={handlesetAccountingTabsValue}
        />
        <AccountingTabs accountingTabsValue={accountingTabsValue} />
      </>
    ) : (
      <AccessDeny />
    );
  const ReferralPage =
    userTypes.length > 0 ? (
      <>
        <ReferralMenu
          referralTabsValue={referralTabsValue}
          handlesetReferralTabsValue={handlesetReferralTabsValue}
        />
        <ReferralTabs referralTabsValue={referralTabsValue} />
      </>
    ) : (
      <AccessDeny />
    );
  // const ScoresPage =
  //   userTypes.length > 0 ? (
  //     <>
  //       <ScoresMenu
  //         scoresTabsValue={scoresTabsValue}
  //         handlesetScoresTabsValue={handlesetScoresTabsValue}
  //       />
  //       <ScoresTabs scoresTabsValue={scoresTabsValue} />
  //     </>
  //   ) : (
  //     <AccessDeny />
  //   );
  const LeitnerPage =
    userTypes.length > 0 ? (
      <>
        <LeitnerMenu
          leitnerTabsValue={leitnerTabsValue}
          handlesetLeitnerTabsValue={handlesetLeitnerTabsValue}
        />
        <LeitnerTabs leitnerTabsValue={leitnerTabsValue} />
      </>
    ) : (
      <AccessDeny />
    );
  const SubtitlesPage =
    userTypes.length > 0 ? (
      <>
        <SubtitlesMenu
          subtitlesTabsValue={subtitlesTabsValue}
          handlesetSubtitlesTabsValue={handlesetSubtitlesTabsValue}
        />
        <SubtitlesTabs subtitlesTabsValue={subtitlesTabsValue} userTypes={userTypes} />
      </>
    ) : (
      <AccessDeny />
    );
  const InfluencerPage =
    userTypes.length > 0 ? (
      <>
        <InfluencerMenu
          influencerTabsValue={influencerTabsValue}
          handlesetInfluencerTabsValue={handlesetInfluencerTabsValue}
        />
        <InfluencerTabs influencerTabsValue={influencerTabsValue} handlesetInfluencerTabsValue={handlesetInfluencerTabsValue} />
      </>
    ) : (
      <AccessDeny />
    );
  const SupportPage = (
    // userTypes.length > 0 ? (
    <>
      <SupportMenu
        supportTabsValue={supportTabsValue}
        handlesetSupportTabsValue={handlesetSupportTabsValue}
      />
      <SupportTabs supportTabsValue={supportTabsValue} />
    </>
  );
  const contactUsPage = (
    <>
      <ContactUsMenu
        contactUsTabsValue={contactUsTabsValue}
        handlesetContactUsTabsValue={handlesetContactUsTabsValue}
      />
      <ContactUsTabs contactUsTabsValue={contactUsTabsValue} />
    </>
  );
  // ) : (
  //   <AccessDeny />
  // );
  const VocabularyPage =
    userTypes.length > 0 ? (
      <>
        <VocabularyMenu
          vocabularyTabsValue={vocabularyTabsValue}
          handlesetVocabularyTabsValue={handlesetVocabularyTabsValue}
        />
        <VocabularyTabs vocabularyTabsValue={vocabularyTabsValue} />
      </>
    ) : (
      <AccessDeny />
    );

  return (
    <Box component="main" sx={{ flexGrow: 12, height: "100%", width: "100%" }}>
      <TabPanel value={mainPageNumber} index={0}>
        {/* <VideoPlayer/> */}
      </TabPanel>
      <TabPanel value={mainPageNumber} index={1}>
        {UserInfoPage}
      </TabPanel>
      <TabPanel value={mainPageNumber} index={2}>
        {PackagesPage}
      </TabPanel>
      <TabPanel value={mainPageNumber} index={3}>
        {VocabularyPage}
      </TabPanel>
      <TabPanel value={mainPageNumber} index={4}>
        {ReferralPage}
      </TabPanel>
      {/* <TabPanel value={mainPageNumber} index={4}>
        {AcademiesPage}
      </TabPanel> */}
      <TabPanel value={mainPageNumber} index={5}>
        {AccountingPage}
      </TabPanel>
      <TabPanel value={mainPageNumber} index={6}>
        {SupportPage}
      </TabPanel>
      <TabPanel value={mainPageNumber} index={7}>
        {LeitnerPage}
      </TabPanel>
      {/* <TabPanel value={mainPageNumber} index={6}>
        {ScoresPage}
      </TabPanel> */}
      <TabPanel value={mainPageNumber} index={8}>
        {contactUsPage}
      </TabPanel>
      {/* <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        /> */}
      <TabPanel value={mainPageNumber} index={9}>
        {SubtitlesPage}
      </TabPanel>
      <TabPanel value={mainPageNumber} index={10}>
        {InfluencerPage}
      </TabPanel>
    </Box>
  );
}

export default MainPages;
